import { define, type, auto, Record, Collection } from 'type-r'

@define 
export class FamilyHistoryCollection<R extends FamilyHistory = FamilyHistory> extends Collection<R> {

}

@define 
export class FamilyHistory extends Record {
    static Collection = FamilyHistoryCollection<FamilyHistory>;
    @auto relation: string
    @auto medicalEyeDisease: string
    @(type(String).as) causeOfDeath: string
}
